import { SessionModeEnum } from '@/enums/SessionModeEnum';

export default {
    title: '수업',
    buttons: {
        start: '수업 시작',
        end: ({ values }: { values: { mode: SessionModeEnum } }) => {
            const { mode } = values;
            return mode === SessionModeEnum.SELF ? '자습 종료' : '수업 종료';
        },
        exit: '나가기',
        review: '살펴보기',
        pause: '일시정지',
        resume: '재개',
        selfDoneConfirm:
            '아직 자습이 진행중이에요. 자습을 이대로 종료할까요?<br />자습을 종료해도 지금까지 학습한 내역은 기록돼요.',
        selfDoneConfirmMessage: '자습 모드를 완료했습니다!',
        goStudentPage: '대기실 가기',
    },
    modal: {
        title: {
            ongoing: '활동 진행중',
            completed: '수업 종료',
        },
        message: {
            ongoing: '수업 종료 시 진행 중인 활동도 같이 종료돼요.\n종료할까요?',
            completed: '수업을 종료할까요?',
        },
    },
    status: {
        ongoing: '진행 중',
        completed: '완료',
        paused: '일시정지',
        preparing: '준비 중',
        waiting: '대기 중',
    },

    timer: {
        format: '{minutes}:{seconds}',
        started: '{time}에 시작됨',
        duration: '{duration}분 진행',
    },

    students: {
        online: '온라인',
        offline: '오프라인',
        total: '전체',
        count: '{count}명',
        countFormat: '{online}/{total}',
        selectAll: '전체 선택',
        selected: '선택됨',
        unselected: '선택 해제',
        notSubmitted: '미제출 학생',
    },

    screen: {
        toggle: '칠판 화면',
        on: 'ON',
        off: 'OFF',
        options: {
            none: '사용 안함',
            basic: '기본 화면',
            waitingRoom: '대기실',
            activity: '활동 화면',
            sessionResult: '수업 결과 화면',
            moduleResult: '활동 결과 화면',
        },
    },

    focus: {
        toggle: '집중 모드',
        on: '집중 모드 켜짐',
        off: '집중 모드 꺼짐',
    },

    star: {
        title: '칭찬별',
        give: '칭찬별 주기',
        comment: '칭찬 메시지',
        comments: {
            great: '잘했어요!',
            excellent: '훌륭해요!',
            good: '좋아요!',
            perfect: '완벽해요!',
            amazing: '대단해요!',
        },
    },

    module: {
        start: '활동 시작',
        end: '활동 종료',
        setting: '활동 설정',
        preview: '미리보기',
        result: '결과 보기',
        inProgress: '활동 진행 중',
        completed: '활동 완료',
        fold: '글감 접기',
        subject: '글감',
    },

    navigation: {
        home: '홈으로',
        waitingRoom: '대기실로',
        result: '결과 보기',
        next: '다음 활동',
        previous: '이전 활동',
    },
};
